<script setup>

	const props = defineProps({
		setCursor: {
			required: true,
			type: Function,
		},
	})

	const calendly = useCalendly()

	const options = {
		url: 'https://calendly.com/operoprague/prohlidka-v-opero?hide_gdpr_banner=1&background_color=1a1a1a&text_color=ffffff&primary_color=ffffff',
		pageSettings: {
			hideEventTypeDetails: true
		}
	}

	onMounted(() => {
		calendly.initInlineWidget()
	})

</script>

<template>
  <div class="contact-header overflow-hidden pb-24 lg:pb-32">
    <div class="navbar-wrapper">
      <Navbar
        :is-dark="true"
        :is-white="true"
        @mouseenter="
          () => {
            setCursor(null, scrollTo, {
              'font-size': '14px',
              background: '#FFF',
              width: '25px',
              height: '25px',
              'z-index': '1',
              position: 'absolute',
              opacity: 0.7,
            });
          }
        "
      />
    </div>

    <div
      class="flex justify-center px-6 relative"
      @mouseenter="
        () => {
          setCursor(null, scrollTo, {
            'font-size': '14px',
            background: '#FFF',
            width: '25px',
            height: '25px',
            'z-index': '1',
            position: 'absolute',
            opacity: 1,
          });
        }
      "
    >
      <div class="max-w-7xl relative z-40">
        <h2 class="h1 contact-hero-text lg:ml-6 mt-32 mb-12 lg:mb-24">
          <TestMask
            :text="useRoute().query.type === 'meeting_room' ? $t('contact.header.meeting_room.title') : $t('contact.header.title')"
            bg-color="#FFC800FF"
            bg-text-color="#FFC800FF"
            :width="450"
            :delay="0"
            class=""
          />
        </h2>
        <div class="grid md:grid-cols-2 gap-20 lg:px-6">
          
          <div>
			<div v-if="useRoute().query.type !== 'meeting_room'" class="mb-12">
            <h3 class="mb-6 txt-q">{{ $t("contact.header.weContact") }}</h3>
            <p
              v-if="
                useRoute().query.from !== 'membership' &&
                useRoute().query.from !== 'event'
              "
            >
              {{ $t("contact.header.weContactRows.part1.row1") }}
              {{ $t("contact.header.weContactRows.part1.row2") }}
              {{ $t("contact.header.weContactRows.part1.row3") }}
              {{ $t("contact.header.weContactRows.part1.row4") }}
            </p>
            <p v-if="useRoute().query.from === 'membership'">
              {{ $t("contact.header.weContactRows.part2.row1") }}
              {{ $t("contact.header.weContactRows.part2.row2") }}
              {{ $t("contact.header.weContactRows.part2.row3")
              }}{{ $t("contact.header.weContactRows.part2.row4") }}
            </p>
            <p v-if="useRoute().query.from === 'event'">
              {{ $t("contact.header.weContactRows.part3.row1") }}
              {{ $t("contact.header.weContactRows.part3.row2") }}
            </p>
			</div>
            <div>
							<FooterContact />
						</div>
          </div>
					<div>
						<div class="mb-0">
							<h3 class="mb-6 txt-q">
							{{ $t(useRoute().query.type == "meeting_room" ? "contact.header.contactUs2" : "contact.header.contactUs") }}
							</h3>
							<div
								v-if="
									useRoute().query.from !== 'membership' &&
									useRoute().query.from !== 'partnership' &&
									useRoute().query.from !== 'booking' &&
									useRoute().query.from !== 'event'
								"
							>
								<p>
									{{ $t("contact.header.writeEmail") }}
									<span class="font-bold">recepce@opero.cz</span> <br />
									{{ $t("contact.header.callUs") }}
									<span class="font-bold">+420 777 167 376</span>
								</p>
								<p>{{ $t("contact.header.weAreAvailable") }}</p>
							</div>
							<div v-if="useRoute().query.from === 'membership'">
								<p>
									<span class="font-bold">{{ $t("contact.header.name") }}</span>
									<br />
									<span class="italic">{{ $t("contact.header.position") }}</span>
								</p>
								<p>{{ $t("contact.header.membershipAndNetworking") }}</p>
								<span class="font-bold">karolina.skodova@opero.cz</span><br />
								<span class="font-bold">+420 734 465 600</span>
							</div>
							<div v-if="useRoute().query.from === 'booking'">
								<p>
									<span class="font-bold">{{ $t("contact.header.name2") }}</span>
									<br />
									<span class="italic">{{ $t("contact.header.position2") }}</span>
								</p>
								<p>{{ $t("contact.header.completeService") }}</p>
								<span class="font-bold">tereza.jacinova@opero.cz</span><br />
								<span class="font-bold">+420 603 434 111</span>
							</div>
							<div v-if="useRoute().query.from === 'partnership'">
								<p>
									<span class="font-bold">{{ $t("contact.header.name3") }}</span>
									<!-- <br /> -->
									<!-- <span class="italic">{{ $t("contact.header.position3") }}</span> -->
								</p>
								<p>{{ $t("contact.header.partnership") }}</p>
								<span class="font-bold">martin.mara@opero.cz</span><br />
								<span class="font-bold">+420 773 635 102</span>
							</div>
							<div v-if="useRoute().query.from === 'event' && useRoute().query.type !== 'meeting_room'">
								<p>
									<span class="font-bold">{{ $t("booking.contact.title") }}</span>
									<br />
									<span class="italic">{{ $t("booking.contact.subtitle") }}</span>
								</p>
								<span class="font-bold">recepce@opero.cz</span><br />
								<span class="font-bold">+420 777 167 376</span>
							</div>
							<div v-if="useRoute().query.type === 'meeting_room'">
								<p class="text-xl">
									<span class="font-bold">{{ $t("booking.contact.title2") }}</span>
								</p>
								<span class="font-bold text-xl">+420 777 167 376</span>
							</div>
						</div>
					
						<div
							v-if="
								useRoute().query.from === 'membership' ||
								// useRoute().query.from === 'event' ||
								useRoute().query.from === 'partnership' ||
								useRoute().query.from === 'menu'
							"
						>
							<h3 class="mb-6 mt-12 txt-q">{{ $t("contact.header.meeting.title") }}</h3>
							<p
								v-if="
									useRoute().query.from !== 'membership' &&
									useRoute().query.from !== 'event'
								"
							></p>
							<p
								v-if="
									useRoute().query.from === 'membership' ||
									useRoute().query.from === 'partnership' ||
									useRoute().query.from === 'menu'
								"
								v-html="$t('contact.header.meeting.text')"
							/>
							<p v-if="useRoute().query.from === 'event'">
								{{ $t("contact.header.meeting.part3.row1") }}
								{{ $t("contact.header.meeting.part3.row2") }}
								{{ $t("contact.header.meeting.part3.row3") }}
								{{ $t("contact.header.meeting.part3.row4") }}
							</p>

							<!-- <a
								:href="
									$i18n.locale === 'cs'
										? 'https://calendly.com/operoprague/prohlidka-v-opero'
										: 'https://calendly.com/operoprague/tour-in-opero'
								"
								target="_blank"
								rel="noopener noreferrer"
							>
								<button
									class="bg-transparent border rounded-full border-black text-black px-4 py-2 mt-6"
								>
									{{ $t("contact.header.meeting.button") }}
								</button>
							</a> -->
							<div class="mt-6">
								<CalendlyInlineWidget v-bind="options" />
							</div>
						</div>
					</div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.contact-header {
  background-color: $color-primary;
}

.contact-hero-text {
  font-size: 48px;
  min-height: 72px;
  width: fit-content;
  font-family: Roboto;
}
</style>
